/**************************************************
 * Nombre:       Tarjetas_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useBotonCantidadTarjeta} from "../Hooks/useBotonCantidadTarjeta";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import img_def from '../../Recursos/img_defecto.png'


const Tarjetas_Producto = ({item}) => {
    const {Boton, cantidad} = useBotonCantidadTarjeta({cantidad: item.cantidad, producto: item})


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, borderColor: '#00000030', pr: 2, pb: 1}}
        >

            <Grid container size={4}>
                <img src={item.img ? item.img : img_def} width={'90%'}/>
            </Grid>

            <Grid container size={8}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={12}>

                    <Grid container size={12}>
                        <Typography
                            sx={{fontWeight: 600, lineHeight: 1.1, fontSize: 14}}>{`${item.nombre}`}</Typography>
                    </Grid>

                    <Grid container size={12} sx={{mt: 0}}>
                        <Typography sx={{fontWeight: 600, fontSize: 10, color: '#00000080'}}>{item.marca}</Typography>
                    </Grid>


                    <Grid container size={12} sx={{mt: 1}}>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: 12
                            }}>{`Valor  ${item.presentacion} ${formatoMoneda(item.valor)}`}</Typography>
                    </Grid>


                    <Grid container size={12} sx={{mt: 0}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-end'}
                            size={12}>

                            <Grid container size={4}>
                                <Boton/>
                            </Grid>

                            <Grid container size={8}>
                                <Grid
                                    container
                                    justifyContent={'flex-end'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>


                                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}>
                                        <Typography sx={{fontWeight: 600, fontSize: 12, color: '#00000080'}}>Valor
                                            total</Typography>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}>
                                        <Typography sx={{
                                            fontWeight: 600,
                                            fontSize: 14,
                                        }}>{formatoMoneda(cantidad * item.valor)}</Typography>
                                    </Grid>

                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjetas_Producto    